import {
  SESSION_ROOM_LEAVE_FALSE,
  SESSION_ROOM_LEAVE_TRUE,
  SESSION_ROOM_METHOD_CLOSE,
  SESSION_ROOM_METHOD_OPEN,
  SMVM_SET_END_SESSION_FAIL,
  SMVM_SET_END_SESSION_REQUEST,
  SMVM_SET_END_SESSION_RESET,
  SMVM_SET_END_SESSION_SUCCESS,
} from "../constants/SessionMethodConstants";

export const smvm_room_status_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case SESSION_ROOM_METHOD_OPEN:
      return { loading: false, roomOpen: true };
    case SESSION_ROOM_METHOD_CLOSE:
      return { loading: false, success: true, roomOpen: false };
    default:
      return state;
  }
};

export const smvm_user_leave_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case SESSION_ROOM_LEAVE_FALSE:
      return { loading: false, leave: false };
    case SESSION_ROOM_LEAVE_TRUE:
      return { loading: false, success: true, leave: true };
    default:
      return state;
  }
};

export const smvm_setEndSession_reducers = (state = { data: {} }, action) => {
  switch (action.type) {
    case SMVM_SET_END_SESSION_REQUEST:
      return { loading: true };
    case SMVM_SET_END_SESSION_SUCCESS:
      return { loading: false, data: action.payload, success: true };
    case SMVM_SET_END_SESSION_FAIL:
      return { loading: false, error: action.payload };
    case SMVM_SET_END_SESSION_RESET:
      return {};
    default:
      return state;
  }
};
